import { useMutation } from '@apollo/client'
import { useState } from 'react'

import { Button, CardBox, Link, NotificationDialog, Stack, Text } from '../../components'
import { mutations } from '../../graphql'

export function DeleteUserTab() {
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [successOpen, setSuccessOpen] = useState(false)

  const [closeAccount, { loading }] = useMutation(mutations.user.closeMyAccount)

  const handleConfirm = async () => {
    try {
      await closeAccount()
      setConfirmOpen(false)
      setSuccessOpen(true)
    } catch (err) {
      console.error('Error closing account:', err)
      setConfirmOpen(false)
    }
  }

  const handleSuccess = () => {
    setSuccessOpen(false)
    window.location.href = '/logout'
  }

  return (
    <Stack>
      <CardBox>
        <Text.H4>Delete User</Text.H4>
        <br />
        <Stack>
          <Text.Body>
            We&apos;re sorry to see you go! Deleting your user account will immediately delete all your associated
            portals and funds across all portals.
          </Text.Body>
          <Text.Body>If you&apos;re sure, please confirm by clicking the button below.</Text.Body>
          <Button onClick={() => setConfirmOpen(true)} color="error">
            Delete My Account
          </Button>
          <br />
          <Text.Body>
            Need help? Contact us at{' '}
            <Link href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}>{process.env.REACT_APP_SUPPORT_EMAIL}</Link>{' '}
            for assistance.
          </Text.Body>
        </Stack>
        <br />

        <NotificationDialog
          open={confirmOpen}
          onClose={() => setConfirmOpen(false)}
          type="alert"
          title="Delete User"
          message={
            <>
              Are you sure you want to delete your account? This will immediately delete all your associated portals and
              funds across all portals.
              <br />
              <br />
              <Text.H7>
                If you have any questions, please contact us at {process.env.REACT_APP_SUPPORT_EMAIL} before proceeding.
              </Text.H7>
            </>
          }
          actions={[
            { label: 'Cancel', onClick: () => setConfirmOpen(false) },
            { label: loading ? 'Deleting...' : 'Delete My Account', onClick: handleConfirm, disabled: loading },
          ]}
        />

        <NotificationDialog
          open={successOpen}
          onClose={handleSuccess}
          type="success"
          title="Account Deleted"
          message="Your account has been deleted and all associated portals and funds have been removed immediately."
          actions={[{ label: 'OK', onClick: handleSuccess }]}
        />
      </CardBox>
    </Stack>
  )
}
